export const getContentApiUrl = state => process.env.CONTENT_API_URL || state.config.contentApi;
export const getEveApiUrl = state => process.env.EVE_API_URL || state.config.eveApi;
